import axios from 'axios';
import customAxios from '../../../utils/customAxios';
import { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import "../../../scss/Components/_modal.scss"
import { useTranslationHook } from '../../../hooks/UseTranslationHook';
import { GlobalVariables } from '../../../globalVar';
import { toast } from 'react-toastify';
import { getToast } from '../../../utils/toastConfig';

function ModalEDelete(props) {
    const {
        equipModalDeleteString,
        equipMDNameString,
        equipMDBrandString,
        equipMDUDateString,
        modalYesString,
        modalNoString,
    } = useTranslationHook();

    var deleteEquipName = localStorage.getItem("equipNameToDelete");
    var deleteEquipBrand = localStorage.getItem("equipBrandToDelete");
    var deleteEquipUpdatedAt = localStorage.getItem("equipUpdatedAtToDelete");

    var deleteEquipId = localStorage.getItem("equipIdToDelete");

    const deleteEquip = () => {
        customAxios.request({
            url: `${GlobalVariables.getURL()}deleteEquip/${deleteEquipId}`,
            method: 'delete',
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        }).then((response) => {
            console.log(response.data)
            hideS();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al eliminar tipo de equipo. Vuelve a intentarlo.' });
        });
    } 
    
    function hideS(){
        props.onHide();
        getToast({ status: 'success', title: 'Tipo de equipo eliminado exitosamente en la base de datos.' });
        props.getEquips();
    }

    function hideN(){
        props.onHide();
    }
  
    return (
        <Modal 
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            backdropClassName="modal-backdrop"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title className="modal-title" id="contained-modal-title-vcenter">
                    {equipModalDeleteString}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <span className='delete-info'><strong>{equipMDNameString}:</strong> {deleteEquipName}</span><br />
                <span className='delete-info'><strong>{equipMDBrandString}:</strong> {deleteEquipBrand}</span><br />
                <span className='delete-info'><strong>{equipMDUDateString}:</strong> {deleteEquipUpdatedAt}</span>
            </Modal.Body>
            <Modal.Footer>
                <button className='modal-button' onClick={() => {deleteEquip()}}><FontAwesomeIcon icon={faWarning}/> {modalYesString}</button>
                <button className='modal-button no' onClick={() => {hideN()}}><FontAwesomeIcon icon={faCircleChevronLeft}/> {modalNoString}</button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalEDelete;